import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
const Login = () =>  import('../components/Login')
const AppScheduler = () =>  import('../components/AppScheduler')
const InspectionList = () =>  import('../components/InspectionList')
const AppMessage = () =>  import('../components/AppMessage')
const AppExpiredPassword = () =>  import('../components/AppExpiredPassword')
const AppForgotPassword = () =>  import('../components/AppForgotPassword')
const AppResetPassword = () =>  import('../components/AppResetPassword')
const AppForgotPasswordSent = () =>  import('../components/AppForgotPasswordSent')

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'inspections',
      component: InspectionList
    }, {
      path: '/login',
      name: 'login',
      component: Login
    }, {
      path: '/calendar',
      name: 'calendar',
      component: AppScheduler
    }, {
      path: '/message',
      name: 'message',
      component: AppMessage
    }, {
      path: '/password-expired',
      name: 'password-expired',
      component: AppExpiredPassword
    }, {
      path: '/change-password',
      name: 'change-password',
      component: AppExpiredPassword
    }, {
      path: '/forgot-password',
      name: 'forgot-password',
      component: AppForgotPassword
    }, {
      path: '/forgot-password-sent',
      name: 'forgot-password-sent',
      component: AppForgotPasswordSent
    }, {
      path: '/password/reset/:token',
      name: 'password-reset',
      component: AppResetPassword
    },
  ]
})

export const unrestrictedRoutes = [
    'login', 'forgot-password', 'password-reset', 'forgot-password-sent',
]

router.beforeEach((to, from, next) => {
  if (!store.getters.authChecked) {
    return next(false)
  }
  // Not logged in and you're trying to access a restricted page
  if (! store.getters.isLoggedIn && ! unrestrictedRoutes.includes(to.name)) {
    return next({name: 'login'})
  }

  const forcingPasswordReset = store.getters.getUser?.force_password_reset !== '0'

  // Logged in and user's force_password_reset is true and you're accessing any page
  // other then the password-expired page
  if (store.getters.isLoggedIn && forcingPasswordReset && to.name !== 'password-expired') {
    return next({name: 'password-expired'})
  }

  // Logged in and you're trying to access the login page
  if (store.getters.isLoggedIn && to.name === 'login') {
    return next({name: 'inspections'})
  }

  next()
})

export default router